// 9fbef606107a605d69c0edbcd8029e5d
import { isClient, getAPIConfig, readCookie, setCookie } from './index';
import { API_CONFIG } from '../services/config';
import { DOMAIN } from '../constants/brandSpecific.constants';

export const CART_ITEM_COUNTER = 'cartItemsCount';
export const SFL_ITEM_COUNTER = 'sflItemsCount_US';
export const SFL_ITEM_COUNTER_CA = 'sflItemsCount_CA';

export { setCookie, readCookie };

/**
 * Remove cookie in browser based on the key
 * @param {string} key - Cookie key/name
 */
export const removeCookie = (key) => {
  if (isClient()) {
    const brand = getAPIConfig().brandId;
    const domainName = DOMAIN[brand.toUpperCase()];
    document.cookie = `${key}=;domain=${domainName};path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

/**
 * Remove cookie in browser based on the key and hostname
 * @param {string} key - Cookie key/name
 */
export const removeAbsoluteCookie = (key) => {
  if (isClient()) {
    document.cookie = `${key}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

export function getCartItemCount() {
  const cookie = readCookie(CART_ITEM_COUNTER);
  return parseInt(cookie || 0, 10);
}

export function getSflItemCount(siteId) {
  // If CA site, fetch CA cookies. Else pick the US cookies for sflCount by default.
  if (siteId === 'CA') {
    return parseInt(readCookie(SFL_ITEM_COUNTER_CA) || 0, 10);
  }
  return parseInt(readCookie(SFL_ITEM_COUNTER) || 0, 10);
}

/**
 * @summary This returns the session Id created
 * from the Quantum cookie needed to tag Raygun errors.
 * @return  {String}  - string of cookies
 */
export function generateSessionId(showComplete) {
  const { sessionCookieKey } = API_CONFIG;

  const cookieValue = readCookie(sessionCookieKey, !isClient() ? getAPIConfig()?.cookie : null);

  return showComplete
    ? cookieValue
    : cookieValue &&
        `${cookieValue.substring(0, 4).toUpperCase()}-${cookieValue.substring(4, 8).toUpperCase()}`;
}
/**
 * @summary This returns all cookies in string format.
 * @return  {String}  - string of cookies
 */
export const getAllCookies = () => {
  return document.cookie;
};

export const feRegionCookieVal = () => {
  const { feCookieKey } = API_CONFIG;
  return readCookie(feCookieKey) || '';
};
